import { Injectable } from '@angular/core';
import { L7Response } from '@biz-models/network/l7-response.model';
import { subdomainUnlinkResp } from '@biz-models/network/login-authenticate-network.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, first, map, share } from 'rxjs/operators';
import { ApiService } from 'src/controls/api/shared/api.service';

@Injectable({
	providedIn: 'root',
})
export class UserService {
	private user = new BehaviorSubject(null);

	constructor() {}

	getAccessToken() {
		return this.getUser().pipe(
			first(),
			map((usr) => usr.access_token),
			share(),
		);
	}

	getUser(): Observable<any> {
		return this.user.asObservable().pipe(filter((u) => !!u));
	}
}
